import { cn } from "@omni/utils/styles";

type CalculatorImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
    size?: "medium" | "large";
};

const CalculatorImage = ({
    size = "medium",
    className,
    alt,
    ...imgProps
}: CalculatorImageProps) => {
    return (
        <img
            className={cn(
                "tw:mt-12",
                {
                    "tw:max-w-[16rem]": size === "medium",
                    "tw:max-w-[24rem] tw:w-full": size === "large"
                },
                className
            )}
            {...imgProps}
            alt={alt || ""}
        />
    );
};

export { CalculatorImage };
